// Chart colours for Magically Linked. The values are CSS variables defined per theme in
// styles/portal.css (`--gf-chart-*`), so charts re-colour with light/dark. Dark values were
// validated with the dataviz six-checks validator against the card surface (#151021); light
// values are the same hue families darkened to ≥4.2:1 on white. Re-run before changing any value:
//
//   categorical (5 slots, adjacent pairs):  node validate_palette.js "#d55181,#3987e5,#d95926,#9085e9,#c98500" --mode dark --surface "#151021"
//     → band/chroma/contrast PASS · worst adjacent CVD ΔE 15.9 · normal-vision ΔE 26.5
//   ordinal funnel ramp (one hue):          node validate_palette.js "#a3345e,#cc5a81,#f67fa5" --ordinal --mode dark --surface "#151021"
//     → monotone, ΔL ≥ 0.06, dim end 2.85:1 — PASS
//   sequential heatmap ramp (magenta, OKLCH L 0.30→0.86): monotone; the dim end recedes toward the
//     surface by design (near-zero), every cell also has a tooltip + the table view.
//
// The original five categorical hues are the LinkedIn sunset families (pink, blue, orange, purple, yellow)
// so charts read on-brand without using the gradient itself. Order is the CVD-safety mechanism:
// assign in this order, never cycle, and colour follows the entity (never its rank).
// Teal and slate extend the palette for unfollows and story views without reassigning existing colours.

export const CATEGORICAL = ["var(--gf-chart-1)", "var(--gf-chart-2)", "var(--gf-chart-3)", "var(--gf-chart-4)", "var(--gf-chart-5)", "var(--gf-chart-6)", "var(--gf-chart-7)"] as const;

/** Funnel steps: first → last (dim → bright). */
export const ORDINAL = ["var(--gf-chart-ord-1)", "var(--gf-chart-ord-2)", "var(--gf-chart-ord-3)"] as const;

/** Heatmap magnitude, low → high. */
export const SEQUENTIAL = [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `var(--gf-chart-seq-${i})`) as readonly string[];

/** Single-series charts (follower growth) use slot 1. */
export const SERIES_1 = CATEGORICAL[0];

/** Chart chrome on the card surface. Text always uses text tokens, never a series colour. */
export const CHROME = {
  surface: "var(--gf-surface)",
  grid: "rgba(var(--gf-line-rgb), 0.10)",
  axis: "rgba(var(--gf-line-rgb), 0.22)",
  text: "var(--gf-text)",
  text2: "var(--gf-text-2)",
  muted: "var(--gf-muted)",
} as const;

/** Colour for a 0–1 magnitude on the sequential ramp. */
export function sequentialColor(t: number): string {
  const i = Math.min(SEQUENTIAL.length - 1, Math.max(0, Math.floor(t * SEQUENTIAL.length)));
  return SEQUENTIAL[i] as string;
}
